import {TokensData} from '@entities/user/types';

enum StorageKeys {
    ACCESS_TOKEN = 'auth.token.access',
    REFRESH_TOKEN = 'auth.token.refresh',
    ACCESS_TOKEN_EXPIRES_IN = 'auth.token.accessExpiresIn',
    REFRESH_TOKEN_EXPIRES_IN = 'auth.token.refreshExpiresIn',
}

export class TokenStorage {
    private static clearStorage(storage: Storage) {
        storage.removeItem(StorageKeys.ACCESS_TOKEN);
        storage.removeItem(StorageKeys.REFRESH_TOKEN);
        storage.removeItem(StorageKeys.ACCESS_TOKEN_EXPIRES_IN);
        storage.removeItem(StorageKeys.REFRESH_TOKEN_EXPIRES_IN);
    }

    private static get storage(): Storage {
        return localStorage;
    }

    public static removeTokens() {
        TokenStorage.clearStorage(sessionStorage);
        TokenStorage.clearStorage(localStorage);
    }

    public static storeTokens(tokensData: TokensData) {
        const {storage} = TokenStorage;
        storage.setItem(StorageKeys.ACCESS_TOKEN, tokensData.access_token);
        storage.setItem(StorageKeys.ACCESS_TOKEN_EXPIRES_IN, tokensData.expires_in.toString());
        storage.setItem(StorageKeys.REFRESH_TOKEN, tokensData.refresh_token);
        storage.setItem(
            StorageKeys.REFRESH_TOKEN_EXPIRES_IN,
            tokensData.refresh_expires_in.toString(),
        );
    }

    public static get accessToken(): string | null {
        return TokenStorage.storage.getItem(StorageKeys.ACCESS_TOKEN);
    }

    public static set accessToken(token: string | null) {
        const {storage} = TokenStorage;
        if (token) {
            storage.setItem(StorageKeys.ACCESS_TOKEN, token);
        } else {
            storage.removeItem(StorageKeys.ACCESS_TOKEN);
        }
    }

    public static get refreshToken(): string | null {
        return TokenStorage.storage.getItem(StorageKeys.REFRESH_TOKEN);
    }

    public static get accessTokenExpiresIn(): string | null {
        return TokenStorage.storage.getItem(StorageKeys.ACCESS_TOKEN_EXPIRES_IN);
    }

    public static get refreshTokenExpiresIn(): string | null {
        return TokenStorage.storage.getItem(StorageKeys.REFRESH_TOKEN_EXPIRES_IN);
    }
}
